export default __webpack_public_path__ + "static/media/cash.8b305510.png";